<template>
  <v-container class="mt-9">
    <v-subheader class="title mb-4 pa-0">
      <v-icon class="mr-3" @click="$router.back()">mdi-arrow-left</v-icon>
      Logs de Sistema
    </v-subheader>
    <v-card flat outlined>
      <v-card-title>
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          flat
          solo
          :disabled="items.length === 0"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="elevation-0"
      >
        <template v-slot:item.date="{ item }">
          <span>{{ convertDate(item.date) }}</span>
        </template>
        <template v-slot:item.body="{ item }">
          <v-btn
            small
            text
            color="primary"
            @click="selectBody(item.body)"
            v-if="item.body"
          >
            Ver Dados
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showBodyDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">Dados Enviados</v-card-title>
        <v-card-text>
          <pre>{{ formattedBody }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showBodyDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      { text: "Data", value: "date", sortable: false },
      { text: "Usuário", value: "user", sortable: false },
      { text: "Ação", value: "action", sortable: false },
      { text: "", value: "body", sortable: false, align: "right", searchable: false },
    ],
    items: [],
    bodySelected: "",
    showBodyDialog: false,
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/operadores/logs").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    convertDate(date) {
      return new Date(date).toLocaleString();
    },
    selectBody(body) {
      try {
        this.bodySelected = JSON.parse(body);
      } catch (e) {
        this.bodySelected = body;
      }
      this.showBodyDialog = true;
    }
  },
  computed: {
    formattedBody() {
      if (!this.bodySelected) return '';
      return JSON.stringify(this.bodySelected, null, 2);
    }
  }
};
</script>

